/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    IdentityMelcoModelsBoolResponse,
    IdentityMelcoModelsBoolResponseFromJSON,
    IdentityMelcoModelsBoolResponseToJSON,
    IdentityMelcoModelsError,
    IdentityMelcoModelsErrorFromJSON,
    IdentityMelcoModelsErrorToJSON,
    IdentityMelcoModelsGenericList1MelcoModelsUserAddOns,
    IdentityMelcoModelsGenericList1MelcoModelsUserAddOnsFromJSON,
    IdentityMelcoModelsGenericList1MelcoModelsUserAddOnsToJSON,
} from '../models';

export interface AddOnsApiAddsOnSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
}

/**
 * 
 */
export class AddOnsApi extends runtime.BaseAPI {

    /**
     */
    async addsOnActivateRaw(): Promise<runtime.ApiResponse<IdentityMelcoModelsBoolResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/addons/activate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityMelcoModelsBoolResponseFromJSON(jsonValue));
    }

    /**
     */
    async addsOnActivate(): Promise<IdentityMelcoModelsBoolResponse> {
        const response = await this.addsOnActivateRaw();
        return await response.value();
    }

    /**
     */
    async addsOnSearchRaw(requestParameters: AddOnsApiAddsOnSearchRequest): Promise<runtime.ApiResponse<IdentityMelcoModelsGenericList1MelcoModelsUserAddOns>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/addons/account`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityMelcoModelsGenericList1MelcoModelsUserAddOnsFromJSON(jsonValue));
    }

    /**
     */
    async addsOnSearch(requestParameters: AddOnsApiAddsOnSearchRequest): Promise<IdentityMelcoModelsGenericList1MelcoModelsUserAddOns> {
        const response = await this.addsOnSearchRaw(requestParameters);
        return await response.value();
    }

}
